import { render, staticRenderFns } from "./UnfreezeModal.vue?vue&type=template&id=bbcb3566"
import script from "./UnfreezeModal.vue?vue&type=script&lang=js"
export * from "./UnfreezeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports